import { defineStore } from "pinia";
import { ref } from "vue";
import { useToast } from "vue-toastification";
import folderService from "@/services/folders";
import fileService from "@/services/files";

export const useFilesStore = defineStore("files", () => {
  const toast = useToast();
  const loading = ref(false);

  async function fetchFilesGrid(payload) {
    loading.value = true;
    try {
      const res = await fileService.getFilesGrid(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function createFolder(payload) {
    loading.value = true;
    try {
      const res = await folderService.createFolder(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function editFolder(payload) {
    loading.value = true;
    try {
      const res = await folderService.editFolder(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function deleteFolder(payload) {
    loading.value = true;
    try {
      const res = await folderService.deleteFolder(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function deleteFile(payload) {
    loading.value = true;
    try {
      const res = await fileService.deleteFile(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function moveFileAndFolder(payload) {
    loading.value = true;
    try {
      const res = await fileService.moveFileAndFolder(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function editFileName(payload) {
    loading.value = true;
    try {
      const res = await fileService.editFileName(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    fetchFilesGrid,
    createFolder,
    editFolder,
    deleteFolder,
    deleteFile,
    moveFileAndFolder,
    editFileName,
  };
});
